@if (!loaded) {
  <div class="center loader-circle">
    <img imageName="loader.gif" [common]="true" alt="loader" width="80px" />
  </div>
}
@if (loaded) {
  <div class="main">
    <div class="custom-wrapper">
      <div class="center logo">
        <app-logo></app-logo>
      </div>
      <div class="login-content">
        <div class="login-content-wrapper">
          <h2>Registration</h2>
          <div class="form-content">
            @if (isError && errorMsg) {
              <div role="alert" class="text-danger mb-2 mt-2">
                {{ errorMsg }}
              </div>
            }
            <form [formGroup]="userForm">
              <div class="form-group mb-2">
                <label>
                  Username
                  <span class="input-required text-w-600">*</span>
                </label>
                <input formControlName="userName" type="text" class="form-control" />
                @if (
                  userForm.get('userName')?.errors?.required && userForm.get('userName')?.touched
                ) {
                  <span class="text-danger">Please enter a username.</span>
                }
                @if (
                  userForm.get('userName')?.errors?.pattern && userForm.get('userName')?.touched
                ) {
                  <span class="text-danger">
                    Please enter a valid username that includes only letters, numbers, underscores
                    (_), and hyphens (-).
                  </span>
                }
              </div>
              <div class="form-group mb-2">
                <label>
                  Email
                  <span class="input-required text-w-600">*</span>
                </label>
                <input formControlName="email" type="text" class="form-control" />
                @if (userForm.get('email')?.errors?.required && userForm.get('email')?.touched) {
                  <span class="text-danger">Please enter an email address.</span>
                }
                @if (userForm.get('email')?.errors?.pattern && userForm.get('email')?.touched) {
                  <span class="text-danger">Please enter a valid email address.</span>
                }
              </div>
              <div class="form-group mb-2">
                <label>
                  Contact Number
                  <span class="input-required text-w-600">*</span>
                </label>
                <input formControlName="contactNumber" type="text" class="form-control" />
                @if (
                  userForm.get('contactNumber')?.errors?.required &&
                  userForm.get('contactNumber')?.touched
                ) {
                  <span class="text-danger">Please enter your contact number.</span>
                }
                @if (
                  (userForm.get('contactNumber')?.errors?.minlength ||
                    userForm.get('contactNumber')?.errors?.maxlength) &&
                  userForm.get('contactNumber')?.touched
                ) {
                  <span class="text-danger">Please enter a valid contact number.</span>
                }
              </div>
              <div class="form-group mb-2">
                <label>First Name</label>
                <p class="text-w-700">{{ userForm.get('firstName')?.value }}</p>
              </div>
              <div class="form-group mb-2">
                <label>Last Name</label>
                <p class="text-w-700">{{ userForm.get('lastName')?.value }}</p>
              </div>
              <div class="form-group mb-2">
                <label>Date of Birth (MM-DD-YYYY)</label>
                <p class="text-w-700">
                  {{ userForm.get('dateOfBirth')?.value | date: 'MM-dd-yyy' }}
                </p>
              </div>
              <div class="form-group mb-2">
                <label>Card ID</label>
                <p class="text-w-700">{{ userForm.get('cardId')?.value }}</p>
              </div>
              <div class="form-group mb-2">
                <label>Rx GRP</label>
                <p class="text-w-700">{{ userForm.get('clientId')?.value }}</p>
              </div>
            </form>
          </div>
          <div class="buttons center mb-2">
            @if (isLoading) {
              <img
                class="loader"
                imageName="loader.gif"
                [common]="true"
                alt="loader"
                width="80px"
              />
            }
            @if (!isLoading) {
              <button
                [disabled]="userForm.invalid"
                (click)="complete()"
                mat-raised-button
                type="submit"
                class="primary-button uppercase"
              >
                Register
              </button>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}
<ng-template #error>
  <div class="toaster-bg error d-flex justify-content-center">
    <mat-icon class="icon-error mr-1"></mat-icon>
    <span>{{ errorMsg }}</span>
  </div>
</ng-template>
